import React, { lazy, Suspense } from "react";

const LazyTajRentReport = lazy(() => import("./TajRentReport"));
const LazyTajSellReport = lazy(() => import("./TajSellReport"));
const LazyAllRaportAgentRatio = lazy(() => import("./AllRaportAgentRatio"));
const LazyBoxRaport = lazy(() => import("./BoxRaport/BoxRaport"));
const LazyPrintBoxReport = lazy(() => import("./BoxRaport/PrintBoxReport"));
const LazyPrintIncome = lazy(() => import("./incomeReport/PrintIncome"));
const LazyAgentPerformance = lazy(() =>
  import("./AgentPerformance/AgentPerformance")
);
export const PrintIncome = () => (
  <Suspense fallback="loading...">
    <LazyPrintIncome />
  </Suspense>
);
const LazyIncome = lazy(() => import("./incomeReport/Income"));
export const Income = () => (
  <Suspense fallback="loading...">
    <LazyIncome />
  </Suspense>
);
export const AgentPerformance = () => (
  <Suspense fallback="loading...">
    <LazyAgentPerformance />
  </Suspense>
);
export const TajRentReport = () => (
  <Suspense fallback="loading...">
    <LazyTajRentReport />
  </Suspense>
);
export const TajSellReport = () => (
  <Suspense fallback="loading...">
    <LazyTajSellReport />
  </Suspense>
);
export const AllRaportAgentRatio = () => (
  <Suspense fallback="loading...">
    <LazyAllRaportAgentRatio />
  </Suspense>
);
export const BoxRaport = () => (
  <Suspense fallback="loading...">
    <LazyBoxRaport />
  </Suspense>
);
export const PrintBoxReport = () => (
  <Suspense fallback="loading...">
    <LazyPrintBoxReport />
  </Suspense>
);
